<template>
  <div id="pix-success-page">
    <YboxIframe v-if="isPaid" :amount=device.payment.amount :uuid=device.payment.planUuid></YboxIframe>
    <div class="success-page__header">
      <img :src="iconSuccessURL" alt="Sucesso!">
      <h2>{{ headerTitle }}</h2>
      <p v-html="headerText"></p>
    </div>

    <div class="success-page__content">
      <div v-if="!isPaid" class="success-page__block">
        <div class="success-page__block__column">
          <p>
            QR code expira em <strong>24 horas</strong> <br />
            <span>Gerado em {{ qrCodeGenerationDate }}</span>
          </p>

          <img :src="device.payment.url" alt="Pix QR Code" />

          <div class="success-page__block__column--footer">
            <p>
              <span>Total:</span>
              <strong>{{ device.payment.amount | currencyBRL }}</strong>
            </p>

            <Button
              label="Copiar código Pix"
              theme="purple-filled"
              @click.prevent.stop="clickToCopy(device.payment.qrCodeTextImage, 'pixCode')"
            />
          </div>
        </div>

        <div class="success-page__block__column">
          <ul>
            <li>1. Abra o app da sua instituição financeira ou banco;</li>
            <li>2. Na área de Pix, leia o QR code ou copie e cole o código;</li>
            <li>3. Revise as informações e confirme;</li>
            <li>4. Assim que o pagamento aprovar a tela irá atualizar seu pedido aprovado.</li>
          </ul>

          <p>
            <strong>Atenção:</strong> Nós também te enviamos um email com validade de 24 horas para pagamento,
            caso não encontre, verifique a caixa de ”spam”.
          </p>

          <div class="success-page__block__column--info">
            <strong>O Pagamento ja foi confirmado?</strong>

            <a v-if="!loadingPixPaymentStatus" href="" @click.prevent.stop="checkPayment(true)">Clique aqui</a>
            <img v-else :src="loaderURL" alt="Carregando.." />
          </div>
        </div>
      </div>

      <NPS />

      <div class="success-page__block">
        <h3>Resumo da compra</h3>

        <div class="success-page__block__row">
          <p>
            <span>Subtotal:</span>
            <strong>{{ device.payment.amount | currencyBRL }}</strong>
          </p>
        </div>

        <div class="success-page__block__row row-footer">
          <p>
            <span>Valor Total:</span>
            <strong>{{ device.payment.amount | currencyBRL }}</strong>
          </p>
        </div>
      </div>

      <div class="success-page__block">
        <span class="icon icon__pix">Pagamento via Pix</span>
      </div>

      <div class="success-page__block">
        <div class="success-page__accordion">
          <div class="success-page__accordion-head">
            <div class="success-page__accordion-head-title">
              <img :src="iconDeviceURL" alt="Aparelho">
              <span>{{ device.nome | capitalize }}</span>
            </div>

            <button v-if="isDesktop" @click.prevent.stop="toggleDetails" :class="{'opened': showDetails}">
              <span>Ver detalhes</span>
            </button>
          </div>

          <div v-if="showDetails" class="success-page__accordion-content">
            <div class="success-page__accordion-content-row">
              <img :src="iconCoverageURL" alt="Cobertura">
              <p>
                <strong>Cobertura: </strong>
                <span>Roubo</span>
                <span v-if="somenteRoubo"> e Furto</span>
                <span v-else>, Furto, Quebra, Líquido</span>
              </p>
            </div>

            <div class="success-page__accordion-content-row">
              <img :src="iconValidityURL" alt="Vigência">
              <p>
                <strong>Vigência do seguro: </strong>
                <span>12 meses (Franquia de 25% do valor do aparelho parcelada em até 4x)</span>
              </p>
            </div>

            <div v-if="device.payment.isRenovation" class="success-page__accordion-content-row">
              <img :src="iconCoverageURL" alt="Ícone documento">
              <p>
                <strong>{{ device.payment.isRenovation ? 'Seguro sem carência: ': 'Carência de 30 dias: '}}</strong>
                <span>Vigência iniciada em {{ device.renewalStartDate }}</span>
              </p>
            </div>

            <div v-if="hasProtectedBag" class="success-page__accordion-content-row">
              <img :src="iconCoverageURL" alt="Cobertura">
              <p>
                <strong>{{ device.protectedBag.bagName }} </strong>
                <span>(Transações digitais, pix e itens da bolsa)</span>
              </p>
              <a class="terms" :href="device.protectedBag.termsLink" target="_blank">
                <img class="terms__icon" :src="iconDocument" alt="Ícone documento">
                <span class="terms__title">Condições gerais</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="success-page__footer">
        <Button
          label="Continuar navegando"
          icon="chevron-left"
          theme="link"
          @click="$router.push('/')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/components/ui/Button'
import { mapState } from 'vuex'
import moment from 'moment'

import { checkPixPayment } from '@/api/services.js'
import YboxIframe from '../YboxIframe/index.vue'

import NPS from '@/components/NPS/index.vue'

export default {
  name: 'Pix',
  components: {
    Button,
    YboxIframe,
    NPS
  },
  data () {
    return {
      showDetails: false,
      isDesktop: true,
      isPaid: false,
      loadingPixPaymentStatus: false,
      timer: ''
    }
  },
  computed: {
    ...mapState(['device']),
    somenteRoubo () {
      return this.device.somenteRoubo
    },
    headerTitle () {
      return this.isPaid
        ? 'Seu pagamento foi aprovado com sucesso'
        : 'Seu pedido foi confirmado com sucesso'
    },
    headerText () {
      return this.isPaid
        ? `Você receberá no e-mail <strong>${this.emailString}</strong> a confirmação da sua compra e o link de acesso para começar a utilizar o Seguro Celular e Portáteis.`
        : `Segue abaixo as instruções para pagamento e confirmação da sua compra. Assim que confirmado, você receberá os detalhes do serviço contratado no email <strong>${this.emailString}</strong>.`
    },
    qrCodeGenerationDate () {
      return moment(this.device.payment.createdDateBR)
        .format('DD/MM/YYYY - HH[h]mm')
    },
    loaderURL () {
      return require(`@/assets/svg/loader-dark.svg`)
    },
    iconSuccessURL () {
      return require(`@/assets/svg/icon-success-purple.svg`)
    },
    iconDeviceURL () {
      return require(`@/assets/svg/icon-device-cellphone.svg`)
    },
    iconCoverageURL () {
      return require(`@/assets/svg/icon-coverage-purple.svg`)
    },
    iconValidityURL () {
      return require(`@/assets/svg/icon-validity-purple.svg`)
    },
    iconDocument () {
      return require(`@/assets/svg/icon-document-purple.svg`)
    },
    emailString () {
      return this.device.personalData.email
        ? this.device.personalData.email
        : 'de cadastro '
    },
    hasProtectedBag () {
      return !!this.device.protectedBag
    }
  },
  created () {
    this.timer = setInterval(this.checkPayment, 60000)
  },
  mounted () {
    const windowSize = window.innerWidth

    if (windowSize <= 768) {
      this.isDesktop = false
      this.showDetails = true
    }
  },
  beforeDestroy () {
    this.cancelAutoCheckForPayment()
  },
  methods: {
    clickToOpen (url) {
      return window.open(url, '_blank')
    },
    clickToCopy (text, action) {
      const actions = {
        pixCode: ' O código do Pix foi copiado para sua área de transferência.'
      }

      this.showToast('success', actions[action])
      return navigator.clipboard.writeText(text)
    },
    toggleDetails () {
      this.showDetails = !this.showDetails
    },
    showToast (icon, msg) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', this.$swal.stopTimer)
          toast.addEventListener('mouseleave', this.$swal.resumeTimer)
        }
      })

      Toast.fire({
        icon,
        title: msg
      })
    },
    async checkPayment (isManual = false) {
      this.loadingPixPaymentStatus = true

      return checkPixPayment(this.device.payment.uuid)
        .then((response) => {
          if (response.data.status === 'PAID') {
            this.isPaid = true
            this.cancelAutoCheckForPayment()
            this.showToast('success', 'Pagamento identificado com sucesso.')
          } else if (response.data.status === 'EXPIRED') {
            console.log('VENCIDO')
          } else {
            if (isManual) {
              this.showToast('warning', 'Pagamento ainda não identificado. Aguarde alguns minutos e tente novamente.')
            }
          }
        })
        .catch((e) => console.error('<<< Error fetching pix payment status: ', e))
        .finally(() => {
          this.loadingPixPaymentStatus = false
        })
    },
    cancelAutoCheckForPayment () {
      return clearInterval(this.timer)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../SuccessPage.scss';

#pix-success-page {
  align-items: center;
  display: flex;
  flex-direction: column;

  .success-page__header {
    max-width: 752px;
    text-align: center;
    padding-top:32px;
    width: 100%;

    img {
      margin-bottom: 12px;
    }
  }

  .success-page__content {
    max-width: 944px;
    width: 100%;

    .success-page__block {
      align-items: center;
      flex-shrink: 0;
      flex-wrap: wrap;
      justify-content: flex-end;

      span {
        margin-right: auto;
      }

      button:not(#btn-copiar-código-pix) {
        margin-top: 16px;
        width: 100%;

        @media (min-width: 768px) {
          margin-left: 16px;
          margin-top: 0;
          width: fit-content;
        }
      }

      #btn-copiar-código-pix {
        width: 100%;
        margin-top: 32px;
      }

      &__column {
        &:nth-child(1) {
          text-align: center;
          width: 100%;

          @media (min-width: 768px) {
            width: 40%;
          }

          p {
            color: #707070;
            font-family: Rubik, sans-serif;
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 20px;
            text-align: center;

            span {
              color: #979797;
              display:block;
              font-family: Rubik, sans-serif;
              font-style: normal;
              font-weight: normal;
              font-size: 14px;
              line-height: 17px;
              margin-top: 8px;
            }

            strong {
              color: #444444;
              font-family: Rubik, sans-serif;
              font-style: normal;
              font-weight: bold;
              font-size: 14px;
              line-height: 17px;
            }
          }

          img {
            border-radius: 8px;
            border: 0.8px solid #F4F4F4;
          }

          .success-page__block__column--footer {
            border-bottom: 1px solid #C8C8C830;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            margin-top: 14px;
            margin-bottom: 24px;
            padding: 0 13% 24px;

            @media (min-width: 768px) {
              border-bottom: none;
            }

            p {
              align-items: center;
              display: flex;
              justify-content: space-between;
              margin: 0;
            }
          }
        }

        &:nth-child(2) {
          color: #707070;
          margin-bottom: auto;
          width: 100%;

          @media (min-width: 768px) {
            padding: 0 0 0 50px;
            width: 60%;
          }

          @media (min-width: 997px) {
            padding: 0;
          }

          ul {
            list-style: none;

            li {
              margin-bottom: 38px;
            }
          }

          p {
            margin: 4px 0 28px;
          }

          .success-page__block__column--info {
            background-color: #F4F4F4;
            padding: 16px;
            width: 100%;

            strong {
              color: #595959;
              font-family: Rubik, sans-serif;
              font-style: normal;
              font-weight: bold;
              font-size: 16px;
              line-height: 22px;
              margin-right: 14px;
            }

            a {
              color: #6320E9;
              font-family: Rubik, sans-serif;
              font-style: normal;
              font-weight: normal;
              font-size: 16px;
              line-height: 24px;
            }

            img {
              width: 20px;
            }
          }
        }
      }

      &__row {
        flex-shrink: 0;
        flex-wrap: wrap;

        p {
          display: flex;
          margin: 0;
          width: 100%;

          + p {
            margin-top: 12px;
          }

          span {
            color: #444444;
            font-family: Rubik, sans-serif;
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 19px;
          }

          strong {
            color: #444444;
            font-family: Rubik, sans-serif;
            font-style: normal;
            font-weight: 700;
            font-size: 16px;
            line-height: 19px;
            margin-left: auto;
            text-align: right;
          }
        }
      }

      .success-page__accordion {
        width: 100%;

        &-head {
          align-items: center;
          display: flex;
          justify-content: space-between;
          margin-top: 10px;

          &-title {
            align-items: center;
            display: flex;
            justify-content: flex-start;

            img {
              margin-right: 16px;
              width: 32px;
            }

            span {
              color: #444444;
              font-family: Oscine, sans-serif;
              font-style: normal;
              font-weight: bold;
              font-size: 18px;
              line-height: 23px;
            }
          }

          button {
            &.opened {
              span {
                &::before {
                  transform: rotate(0);
                  transition: all ease 0.2s;
                }
              }
            }

            &:focus {
              outline:0;
            }

            span {
              display: inline-block;
              padding-right: 20px;
              position: relative;

              &::before {
                background-image: url(~@/assets/svg/chevron-up.svg);
                content: '';
                height: 7px;
                position: absolute;
                right: 0;
                top: calc(50% - 3.5px);
                transform: rotate(180deg);
                transition: all ease 0.2s;
                width: 14px;
              }
            }
          }
        }

        &-content {
          margin-top: 22px;

          &-row {
            align-items: center;
            border-top: solid 1px #BDC2C630;
            display: flex;
            padding: 20px 0;
            justify-content: flex-start;
            text-align: left;

            &:last-child {
              padding-bottom: 0;
            }

            img:not(.terms__icon) {
              margin-right: 16px;
              width: 32px;
            }

            p {
              margin: 0;

              span {
                color: #444444;
                font-family: Oscine, sans-serif;
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                line-height: 21px;
              }

              strong {
                color: #444444;
                font-family: Oscine, sans-serif;
                font-style: normal;
                font-weight: 700;
                font-size: 16px;
                line-height: 21px;
              }
            }
          }
        }
      }
    }

    .success-page__footer {
      align-items: center;
      display: flex;
      justify-content: center;
      padding: 30px 0;
    }
  }

  .terms {
    margin-left: auto;
    display: flex;
    align-items: center;
    font-weight: bold;
    color: #3F4956;

    @media (max-width: 959px) {
      font-size: 11px;
      flex-direction: column;
      text-align: center;
    }

    @media (max-width: 767px) {
      max-width: 67px;
    }

    &__icon {
      max-width: 20px;
      margin-right: 7px;

      @media (max-width: 959px) {
        margin-right: 0;
        margin-bottom: 3px;
      }
    }

    &__title {
      line-height: 1.1;
    }
  }
}
</style>
